import React, { useState } from "react";
import { Button } from "components";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import {
  SUBSCRIPTION_ADDON_REQUESTS_BOOST_1M,
  SUBSCRIPTION_ADDON_REQUESTS_BOOST_300K,
} from "constants/addons";
import { toast } from "react-toastify";
import { ButtonProps } from "components/UI/Button";
import { redirectToStripeAddonsCheckout } from "hooks/useSubscriptionAddons";

interface Props extends Omit<ButtonProps, "children"> {
  boost: "REQUESTS_BOOST_1M" | "REQUESTS_BOOST_300K";
  successCallbackPath: string;
  cancelCallbackPath: string;
  onBehalfWorkspaceId?: string;
}

const RequestBoostButton = ({
  boost,
  successCallbackPath,
  cancelCallbackPath,
  onBehalfWorkspaceId,
  ...rest
}: Props) => {
  const router = useRouter();
  const [inProgress, setInProgress] = useState(false);
  const { data: session } = useSession();

  return (
    <>
      <Button
        variant="animated-gradient"
        uppercase
        disabled={!session || inProgress}
        loading={inProgress}
        onClick={async () => {
          setInProgress(true);
          try {
            if (!session?.user?.email) {
              return;
            }

            const boostAddon =
              boost === "REQUESTS_BOOST_300K"
                ? SUBSCRIPTION_ADDON_REQUESTS_BOOST_300K
                : SUBSCRIPTION_ADDON_REQUESTS_BOOST_1M;
            const response = await redirectToStripeAddonsCheckout(
              boostAddon.stripePriceId,
              {
                successCallbackPath: successCallbackPath,
                cancelCallbackPath: cancelCallbackPath,
                onBehalfWorkspaceId: onBehalfWorkspaceId,
              }
            );
            await router.push(response.data.url);
            setInProgress(false);
          } catch (error) {
            console.error(`Error while creating Checkout session.`, error);
            toast.error(`Error while creating Checkout session.`);
            setInProgress(false);
          }
        }}
        {...rest}
      >
        Boost requests
      </Button>

      <style jsx>{``}</style>
    </>
  );
};

export default RequestBoostButton;
